import React from "react"
import * as Styles from "./SpinnerLoader.styles"

export const SpinnerLoader: React.FC = () => (
  <Styles.Container>
    <Styles.Circle variant="circle-1" />
    <Styles.Circle variant="circle-2" />
  </Styles.Container>
)
